const WEIGHED_PRODUCT_BARCODE_PATTERN = /^\d{5}$/;
const RESERVED_EMPTY_SLOT_PREFIX = "99";

export const normalizeStoreBarcodes = (barcodes: unknown): string[] => {
  if (!Array.isArray(barcodes)) return [];

  const values = new Set<string>();

  barcodes.forEach((barcode) => {
    const value = String(barcode).trim();
    if (value) values.add(value);
  });

  return Array.from(values);
};

export const haveSameStoreBarcodes = (left: unknown, right: unknown): boolean => {
  const leftValues = new Set(normalizeStoreBarcodes(left));
  const rightValues = new Set(normalizeStoreBarcodes(right));

  if (leftValues.size !== rightValues.size) return false;

  return Array.from(leftValues).every((barcode) => rightValues.has(barcode));
};

export type StoreBarcodeValidationError = "format" | "reserved_prefix" | null;

/**
 * Product barcode rules that can be decided without knowing another product's
 * data. Cross-product uniqueness remains a server-side submit validation.
 */
export const validateStoreBarcodes = (
  barcodes: unknown,
  isWeighedProduct: boolean,
): StoreBarcodeValidationError => {
  if (!isWeighedProduct) return null;

  const values = normalizeStoreBarcodes(barcodes);

  if (values.some((barcode) => !WEIGHED_PRODUCT_BARCODE_PATTERN.test(barcode))) {
    return "format";
  }

  if (values.some((barcode) => barcode.startsWith(RESERVED_EMPTY_SLOT_PREFIX))) {
    return "reserved_prefix";
  }

  return null;
};
